import { accUnaccLabels } from "@/lib/transformers/UnaccompaniedTransformer";

export const formatUnaccompanied = (
  unaccompanied: string | null | undefined
) => {
  switch (unaccompanied) {
    case "Y":
      return accUnaccLabels.UNACC;
    case "N":
      return accUnaccLabels.ACC;
    case null:
    case undefined:
    case "":
      return accUnaccLabels.BOTH;
    default:
      return unaccompanied;
  }
};
